import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { AdminDashboardModel } from "src/app/model/AdminDashboardModel";
import { CheckerDashboardModel } from "src/app/model/CheckerDashboardModel";
import { InternalModeratorDashboardModel } from "src/app/model/InternalModeratorDashboardModel";
import { MakerDashboardModel } from "src/app/model/MakerDashboardModel";
import { NodalOfficerDashboardModel } from "src/app/model/NodalOfficerDashboardModel";
import { HomeService } from "src/app/services/home.service";

@Component({
  selector: "app-secure-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  userName: string;
  makerDashboardModel: MakerDashboardModel;
  checkerDashboardModel: CheckerDashboardModel;
  adminDashboardModel: AdminDashboardModel;
  internalModeratorDashboardModel: InternalModeratorDashboardModel;
  nodalOfficerDashboardModel: NodalOfficerDashboardModel;
  loaded: boolean = false;
  date: Date;

  constructor(private router: Router, private homeService: HomeService, 
    private modalCtrl: ModalController) { }

  ngOnInit(): void { 
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    console.log(roles);

    if(roles?.indexOf('ADMIN') >= 0) {
      this.homeService.fetchNodalOfficerDashboard().subscribe(dashboard => {
        this.nodalOfficerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    }
    else if(roles?.indexOf('MODERATION_MAKER') >= 0) {
      this.homeService.fetchMakerDashboard().subscribe(dashboard => {
        this.makerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    }
    else if(roles?.indexOf('MODERATION_CHECKER') >= 0) {
      this.homeService.fetchCheckerDashboard().subscribe(dashboard => {
        this.checkerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    }
    // else if(roles?.indexOf('INTERNAL_MODERATOR') >= 0) {
    //   this.homeService.fetchModerationInchargeDashboard().subscribe(dashboard => {
    //     this.moderationInchargeDashboardModel = dashboard;
    //     this.loaded = true;
    //     this.date = new Date();
    //   });
    // }
    else if(roles?.indexOf('NODAL_OFFICER') >= 0 || roles?.indexOf('MANAGER') >= 0) {
      this.homeService.fetchNodalOfficerDashboard().subscribe(dashboard => {
        this.nodalOfficerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    }
    // else if(roles?.indexOf('MODERATION_INCHARGE') >= 0) {
    //   this.homeService.fetchModerationInchargeDashboard().subscribe(dashboard => {
    //     this.moderationInchargeDashboardModel = dashboard;
    //   });
    // }
  }

  onClickPendingModeration() {
    this.router.navigate(['/secure', 'moderation-list']);
  }

  async assignModerationCases() {
    // const modal = await this.modalCtrl.create({
    //   component: AssignModerationModalComponent,
    //   cssClass: 'master-modal',
    //   componentProps: {
    //       obj: null
    //   }
    // });
    // modal.present();

    // const { data, role } = await modal.onWillDismiss();
      
    // if (role === 'submit') {
    //   this.homeService.assignModerationCases(data).subscribe(res => {
    //     if(res.status === 'SUCCESS') {
    //       this.ngOnInit();
    //     }
    //     else {
    //       this.homeService.errorToast(res.errorMessage);
    //     }
    //   });
    // }
  }

  refresh() {
    this.ngOnInit();
  }

}